import { useState } from 'react'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'
import { resetPassword } from '../../Services/AuthServices'

const useCreateNewPassword = () => {

    const [password, setPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [isLoading, setIsLoading] = useState(false)
    const email = localStorage.getItem("forgot_email")
    const code = localStorage.getItem("otp_code")
    const navigate = useNavigate()


    const handlePassword = (e) => { setPassword(e.target.value) }
    const handleConfirmPassword = (e) => { setConfirmPassword(e.target.value) }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setIsLoading(true)
        let response = await resetPassword({ email, code, password, confirm_password: confirmPassword })
        if (response.statusCode === 200) {
            toast?.success(response?.response?.message)
            setIsLoading(false)
            navigate("/")
        } else if (response.statusCode === 401) {
            toast?.error(response?.errors)
            setIsLoading(false)
        } else {
            for (const [key, value] of Object.entries(response?.errors)) {
                toast?.error(value)
            }
            setIsLoading(false)
        }
        setIsLoading(false)
    }
    return [
        password,
        confirmPassword,
        isLoading,
        handlePassword,
        handleConfirmPassword,
        handleSubmit
    ]
}

export default useCreateNewPassword